"use client"
import { gql } from "graphql-request";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import useElementInView from "src/lib/client/useElementInView";
import { useFilminfo } from "src/lib/client/useFilminfo";
import type IPremiumLandingPage from "src/lib/types/IPremiumLandingPage";
import styles from "./PromotedVideo.module.css";

type PromotedVideoProps = {
    landingpage: IPremiumLandingPage;
};

type QueryData = {
    movieQuery?: {
        getMovieClipEmbedCode?: string | null;
    } | null;
};

type QueryVariables = {
    clipId: number | null;
    playerId?: number | null;
};

const QUERY = gql`
query ($clipId: Int, $playerId: Int) {
    movieQuery {
        getMovieClipEmbedCode(clipId: $clipId, playerId: $playerId)
    }
}
`;

export default function PromotedVideo({ landingpage }: PromotedVideoProps) {
    const clipId = landingpage.promotedVideoId ?? 0;
    const shouldLoad = clipId > 0;
    const { fiLoading, fiData } = useFilminfo(QUERY, { clipId }, { active: shouldLoad });
    const { ref, isInView } = useElementInView<HTMLDivElement>({ triggerOnce: true });

    if (!shouldLoad) {
        return null;
    }

    const embedCode = fiData?.movieQuery?.getMovieClipEmbedCode ?? null;

    return (
        <div className={styles.promotedVideo} ref={ref}>
            {fiLoading && <LoadingIndicator position="InlineCenter" />}
            {!fiLoading && isInView && embedCode && (
                <div dangerouslySetInnerHTML={{ __html: embedCode }} />
            )}
        </div>
    );
}
